import {
  ScrollArea as ChakraScrollArea,
  type ScrollAreaRootProps,
} from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

/** https://chakra-ui.com/docs/components/scroll-area */
export const ScrollArea = ({
  children,
  ...rootProps
}: PropsWithChildren<ScrollAreaRootProps>) => (
  <ChakraScrollArea.Root {...rootProps}>
    <ChakraScrollArea.Viewport>
      <ChakraScrollArea.Content>{children}</ChakraScrollArea.Content>
    </ChakraScrollArea.Viewport>
    <ChakraScrollArea.Scrollbar>
      <ChakraScrollArea.Thumb />
    </ChakraScrollArea.Scrollbar>
    <ChakraScrollArea.Corner />
  </ChakraScrollArea.Root>
);
